import React from 'react';
import { InputNumber } from 'antd';

const CustomInputNumber = (props) => {
  // eslint-disable-next-line
  return <InputNumber {...props} style={{ width: 150, borderRadius: 20 }} onWheel={(e) => e.target.blur()} />;
};

export default CustomInputNumber;
